var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"iframe-box"}},[_c('h4',[_vm._v(_vm._s(_vm.message))]),_c('p',[_vm._v(_vm._s(_vm.add_message))]),(_vm.url)?_c('iframe',{attrs:{"src":_vm.url}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }